import { FreegamesCommonConfiguration } from "../../api";
import { SetStyles } from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { FreegameBonus2, FreegameBonus2Params, FreegameBonusFactory2 } from "../FreegameBonus/FreegameBonus2";
import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
import { SlotGameType1_2 } from "../SlotGameType1_2";

// namespace SlotGames2
// {
	export class ShiningChalice2 extends SlotGameType1_2
	{
   
		protected override freegameBonusFactory: FreegameBonusFactory2 = new ShiningChaliceFreegame2BonusFactory();
		protected override seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();

		
		//protected slideFactory: SlideFactory = new ShiningChaliceSecondScreenHelpFactory();
		public override TitleLoaded(resourceManager:ResourceManager)
		{
			super.TitleLoaded(resourceManager);

			SetStyles(this.view.querySelector(".title"),
			{
				display:"flex",
				justifyContent:"center",
				margin:"26px",
				//backgroundSize:"contain"


			});
			//this.titleSprite.Scale(1.5);
		}

        protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
        {
        	super.PaytableLoaded(resourceManager);
        	SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
			{
				//HIDE BACKGROUND COLOR
				//backgroundColor:"rgba(0, 0, 0, 0.6)",
			});


        }
		
		// public PrepareFont(resourceManager: ResourceManager)
		// {
			
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/Whakatani-Bold.ttf", "." + this.resid.ScopedResourceName(["font"])));
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/Whakatani-Bold.ttf", this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }



	


		
	}

	class ShiningChalice2Freegame extends FreegameBonus2 
	{

		

		public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
		{
			await super.ResourcesLoaded(loadingStage, resourceManager);

			let freegameStats = this.view.querySelector(".freegame-stats");
			SetStyles(freegameStats,
			{
				bottom: "50px",
				height:"28%",

			});

			//let outter = document.querySelectorAll(".BigWinCountAnimation");
			//outter.style.alignItems="center";
		/* 	this.titleElement.style.width="1840";
			this.titleElement.style.height="410";
			this.titleElement.style.margin="0 auto 0 auto";
			this.titleElement.style.top="0px";
			 */
		}
		
		

	}


	class ShiningChaliceFreegame2BonusFactory extends FreegameBonusFactory2 
	{
		public override CreateFreegameBonus2(gameName: ResourceIdentifier, freeGameConfig: FreegamesCommonConfiguration,  p: FreegameBonus2Params): FreegameBonus2 
		{
			return new ShiningChalice2Freegame(gameName, freeGameConfig,  p);
		}
	}


	// class ShiningChaliceSecondScreenHelpFactory extends SlideFactory
	// {
	// 	public CreateStyle():Partial<CSSStyleDeclaration>
	// 	{
	// 		let style :Partial<CSSStyleDeclaration> = 
	// 		{
	// 			color:"White"
	// 		};
	// 		return style;
	// 	}
	// }
	
// }